import BaseApi from './baseApi';
import ISettingsCompany from '../models/ISettingsCompany';
export default class SettingsCompanyApi extends BaseApi {
    constructor(page: string) {
        super("dataaccess", page);
    }

    async getSettingCompanyId(idCompany: string, keySetting: string) : Promise<ISettingsCompany[]> {
        const json = this.getJsonRead(idCompany, keySetting);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var settingsCompany: ISettingsCompany[] = [];
            settingsCompany = response.data as ISettingsCompany[];
            return settingsCompany;
        } else {
            this.modelState = response.errorState;
        }

        return [];
    }

    private getJsonRead(idCompany: string, keySetting: string) : any {
        const json = {
            "fields": [{
                "Item1": "SettingsCompany",
                "Item2": "value"
            }],
            "tables": [{
                "Item1": "SettingsCompany"
            }],
            "conditions": [{
                "Item1": "SettingsCompany",
                "Item2": "IdCompany",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "AND"
            }, {
                "Item1": "SettingsCompany",
                "Item2": "KeySetting",
                "Item3": "=",
                "Item4": keySetting
            }]
        };
        return json;
    }
}
